import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from "@configs/axios";

const operations = {
  fetchUser: createApiService(
    () => axios.get("/fetchUser"),
    { ...API_CONFIGS.GET_WITH_DATA, context: 'Profile - Fetch User' }
  ),

  accessStatus: createApiService(
    () => axios.get("/user/access_status"),
    { ...API_CONFIGS.GET_WITH_DATA, context: 'Profile - Access Status' }
  ),

  fetchProfile: createApiService(
    () => axios.get("/user/profile"),
    { ...API_CONFIGS.GET_WITH_DATA, context: 'Profile - Fetch Profile' }
  ),
  fetchRemoveProfile: createApiService(
    () => axios.delete("/profile/photo/delete"),
    { ...API_CONFIGS.DELETE, context: 'Profile - Remove Photo' }
  ),

  fetchChangePassword: createApiService(
    (data) => axios.post("/user/changePassword", data),
    {
      ...API_CONFIGS.POST_ACTION,
      context: 'Profile - Change Password',
      transformResponse: (response) => response // Return full response object
    }
  ),

  updateProfile: createApiService(
    (data) => axios.post("/user/updateProfile", data),
    { ...API_CONFIGS.POST_ACTION, context: 'Profile - Update' }
  ),
  uploadPhotoProfile: async (data) => {
    try {
      const res = await axios.post("/user/uploadPhoto", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchScoreAmount: async () => {
    try {
      const res = await axios.get("/scores/summary", {});
      if (res.data) {
        return res.data.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchScoresHistory: async (page = 1, query = "") => {
    const reqQuery = `?page=${page}&query=${query}`;
    try {
      const res = await axios.get(`/scores/history${reqQuery}`, {});
      if (res.data) {
        return res.data.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchScoresExchangeHistory: async (page = 1) => {
    // const reqQuery = `?page=${page}&query=${query}`
    try {
      const res = await axios.get(`/scores/exchange/history`, {});
      if (res.data) {
        return res.data.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  convetScoreToToman: async (lang) => {
    try {
      const res = await axios.get(`/scores/exchange`, {
        headers: {
          "x-lang": `${lang}`, // Replace 'your-lang-value' with the actual value you want to send
        },
        // Skip global error handling in axios interceptor - we handle errors in the component
        skipGlobalErrorHandler: true,
      });
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  biometricApi: async (data) => {
    console.log("🔵 ProfileServices.biometricApi: Starting API call");
    try {
      const res = await axios.post(`/user/biometric`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("🟢 ProfileServices.biometricApi: Success", res.data);
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      console.log("🔴 ProfileServices.biometricApi: Error caught", err);
      console.log("🔴 ProfileServices.biometricApi: Error response", err.response?.data);
      console.log("🔴 ProfileServices.biometricApi: Error status", err.response?.status);

      throw err;
    }
  },
  updateProfileToLevel1: async (data, lang) => {
    console.log("🔵 ProfileServices.updateProfileToLevel1: Starting API call", data);
    try {
      const res = await axios.post("/user/upgradeLevelOne", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "body-type": "no-change",
          "x-lang": `${lang}`,
        },
      });
      console.log("🟢 ProfileServices.updateProfileToLevel1: Success", res.data);
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      console.log("🔴 ProfileServices.updateProfileToLevel1: Error caught", err);
      console.log("🔴 ProfileServices.updateProfileToLevel1: Error response", err.response?.data);
      console.log("🔴 ProfileServices.updateProfileToLevel1: Error status", err.response?.status);

      throw err;
    }
  },
  updateProfileToLevel2: async (data, lang) => {
    try {
      const res = await axios.post("/user/upgradeLevelTwo", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "body-type": "no-change",
          "x-lang": `${lang}`,
        },
      });
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchScoresList: async () => {
    try {
      const res = await axios.get("/scores", {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchAccessLevelZero: async () => {
    try {
      const res = await axios.get("/user/zero_access_level", {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchAccessLevelOne: async () => {
    try {
      const res = await axios.get("/user/access_level_one", {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchAccessLevels: async () => {
    try {
      const res = await axios.get("/user/access_level", {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },

  cancelKycRequest: createApiService(
    () => axios.post("/user/cancel_kyc_request", { status: -1 }),
    { ...API_CONFIGS.POST_ACTION, context: 'Profile - Cancel KYC Request' }
  ),

  requestLevelTwoUpgrade: createApiService(
    () => axios.post("/user/upgradeLevelTwo"),
    { ...API_CONFIGS.POST_ACTION, context: 'Profile - Request Level 2 Upgrade' }
  ),
};

export default operations;
